function formatNumber(num) {
  return num.toLocaleString("de-DE");
}

function getYearCount() {
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 1, 0, 0, 0);

  const diff = now - start;
  const interval = 36 * 60 * 1000;

  return Math.floor(diff / interval);
}

function animateValue(el, start, end, duration) {
  let startTime = null;

  function step(timestamp) {
    if (!startTime) startTime = timestamp;

    const progress = Math.min((timestamp - startTime) / duration, 1);
    const value = Math.floor(progress * (end - start) + start);

    el.textContent = formatNumber(value);

    if (progress < 1) {
      requestAnimationFrame(step);
    }
  }

  requestAnimationFrame(step);
}

function updateCounter() {
  const el = document.getElementById("year-counter");
  if (!el) return;

  const newValue = getYearCount();
  const oldValue = parseInt(el.dataset.value || "0");

  if (newValue !== oldValue) {
    animateValue(el, oldValue, newValue, 800);
    el.dataset.value = newValue;
  }
}

updateCounter();
setInterval(updateCounter, 60000);